import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const sid = hash.split("session_id=")[1]?.split("&")[0];
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        const user = await googleAuth(sid);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.onboarding_complete ? "/app" : "/onboarding", { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
      }
    })();
  }, [googleAuth, navigate, location.hash]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center">
        <div className="font-display text-5xl uppercase tracking-tight">Signing you in…</div>
        {error ? <p className="text-destructive mt-4">{error}</p> : <p className="text-muted-foreground mt-2">One moment</p>}
      </div>
    </div>
  );
}
